import React, { useState } from 'react'
import './App.css'
import TranslationList from '@/resources/TranslationList.json'
import FormulaView from '@/views/FormulaView'
import Ad from './views/Ad'

type SelectItemType =
  | 'none'
  | 'frizz'
  | 'frizzle'
  | 'kafrizz'
  | 'kafrizzle'
  | 'crack'
  | 'crackle'
  | 'kacrack'
  | 'kacrackle'
  | 'woosh'
  | 'swoosh'
  | 'kaswoosh'
  | 'kaswooshle'
  | 'bang'
  | 'boom'
  | 'kaboom'
  | 'kaboomle'
  | 'zam'
  | 'zammle'
  | 'kazam'
  | 'kazammle'
  | 'heal'
  | 'midheal'
  | 'moreheal'
  | 'multiheal'
  | 'gigaslash'
  | 'gigagash'
  | 'lightning-storm'
  | 'hand-of-god'
  | 'whopper-chop'
  | 'boulder-toss'
  | 'solar-flair'

function App() {
  const actions = TranslationList['spells-and-abilities'] as Record<string, string>

  // #region フック

  const [selectItem, setSelectItem] = useState<SelectItemType>('none')

  const [is234] = useState(() => Math.random() < 0.5)

  // #endregion フック

  // #region スタイル

  const adAreaStyle: React.CSSProperties = {
    textAlign: 'center'
  }

  const adHeadlineStyle: React.CSSProperties = {
    margin: '8px 0 0 0',
    fontSize: '20px',
    fontFamily: 'Meiryo',
    fontWeight: 'bold'
  }

  const adMainStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center'
  }

  const hrStyle: React.CSSProperties = {
    marginLeft: '18px'
  }

  const spaceStyle: React.CSSProperties = {
    marginLeft: '10px'
  }

  // #endregion スタイル

  // #region イベント

  const pulldownChange = (e: React.ChangeEvent<HTMLSelectElement>) =>
    setSelectItem(e.currentTarget.value as SelectItemType)

  // #endregion イベント

  const getFormulaView = () => {
    if (selectItem === 'none') {
      return <></>
    }
    return <FormulaView selectItem={selectItem} />
  }

  return (
    <>
      <div style={adAreaStyle}>
        <p style={adHeadlineStyle}>広告</p>
        {is234 ? (
          <div style={adMainStyle}>
            <Ad width={234} height={60} />
            <Ad width={234} height={60} />
            <Ad width={234} height={60} />
          </div>
        ) : (
          <div style={adMainStyle}>
            <Ad width={468} height={60} />
            <Ad width={468} height={60} />
          </div>
        )}
      </div>
      <hr style={hrStyle} />
      <div style={spaceStyle}>
        <h1>ドラゴンクエスト9 呪文・特技ダメージ計算ツール</h1>
        <div style={spaceStyle}>
          使用前に
          <a
            href='https://alittleoldgames.com/blog/dq9-spell-damage-calculation/'
            target='_blank'
            rel='noreferrer'
          >
            こちら
          </a>
          をご一読ください。
          <br />
          <hr />
          呪文・特技を選択：
          <br />
          <select
            name='select-spells-and-abilities'
            style={{ fontSize: '15px', height: '24px' }}
            onChange={pulldownChange}
          >
            <option value='none'>--選択してください--</option>
            {Object.keys(actions).map((s) => (
              <option key={s} value={s}>
                {actions[s]}
              </option>
            ))}
          </select>
          <br />
          <br />
          {getFormulaView()}
          <hr />
          <a href='/tools'>ツール置き場に戻る</a>
          {'　|　'}
          <a href='/'>トップページに戻る</a>
          {'　|　'}
          <a href='/blog/hello-world'>運営者情報</a>
          {'　|　'}
          <a href='/blog/privacypolicy'>プライバシーポリシー</a>
        </div>
      </div>
    </>
  )
}

export default App
